import { fetchCmtpax, fetchPaxsGroup, fetchOverNightStation } from '@/api/passenger'
import { fetchServices } from '@/api/service'
const getCmtpax = (context) => {
  fetchCmtpax().then((response) => {
    context.commit('CMTPAX_UPDATED', _.filter(response, { has_read: 1 }).length)
  })
}

const getPaxsGroup = (context) => {
  fetchPaxsGroup().then((response) => {
    context.commit('PAXSGROUP_UPDATED', response)
    context.commit('GET_PAXS_GROUP', response, { root: true })
  })
}

const getServices = async (context) => {
  await fetchServices().then((response) => {
    let hasServices = { bus: 0, refreshment: 0, taxi: 0, train: 0, rentalcar: 0, hotel: 0, monetary: 0 }
    _.each(response, function (o) {
      if (o.service_id == 4) {
        hasServices.taxi = 1
      }
      if (o.service_id == 2) {
        hasServices.refreshment = 1
      }
      if (o.service_id == 3) {
        hasServices.bus = 1
      }
      if (o.service_id == 5) {
        hasServices.train = 1
      }
      if (o.service_id == 6) {
        hasServices.rentalCar = 1
      }
      if (o.service_id == 1) {
        hasServices.hotel = 1
      }
      if (o.service_id == 21) {
        hasServices.monetary = 1
      }
      if (o.service_id == 23) {
        hasServices.mealPlan = 1
      }
    })
    context.commit('CHECKSERVICES_UPDATED', hasServices)
    context.commit('SERVICES_UPDATED', response)
  })
}

const updateMonetary = (context, data) => {
  context.commit('MONETARY_UPDATE', data)
}

const getOverNightStation = (context) => {
  fetchOverNightStation().then((response) => {
    let overnight_station = response?.data
    if (!_.isUndefined(overnight_station)) {
      context.commit('OVERNIGHTSTATION_UPDATED', overnight_station)
    } else {
      context.commit('OVERNIGHTSTATION_UPDATED', {})
    }
  })
}
export default {
  getCmtpax,
  getPaxsGroup,
  getServices,
  updateMonetary,
  getOverNightStation
}
